import { EntityDTO } from "../../DTO/Entity"

export default function getContributors(entity: EntityDTO) {
    const contributorsAvailable = ['032', '033', '034', '035', '036']
    const contributorsListResponse = { Contributors: contributorsAvailable }

    return contributorsListResponse.Contributors
}